import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { consentModel } from "common/models/page-models/custom-model/consent.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";

@Injectable()
export class ConsentDataService extends DataService<consentModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getProfileConsent,http);
    }
 

   
    createInstance(): consentModel {
        return new consentModel();
    }

    
 
}